import { useContent } from "@/context/ContentContext";
import Merch from "@/components/site/Merch";
import PageLoader from "@/components/site/PageLoader";

export default function MasterclassPage() {
  const c = useContent();
  if (!c) return <PageLoader />;
  return (
    <div className="pt-[72px]">
      <Merch merch={c.merch || {}} />
    </div>
  );
}
